import React, { PropTypes } from 'react';
import { FormattedMessage } from 'react-intl';
import { InlineOverlay, InlineOverlayHeader, InlineOverlayBody } from '@bibliocommons/base-inline-overlay';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import { Generic } from '@bibliocommons/shared-messages';
import MessagingContainer from '../../../../containers/shared/Messaging/MessagingContainer';

export default class BatchAddedToShelfWorkflow extends BcReactComponent {
  render() {
    return (
      <div className="cp-batch-added-to-shelf-workflow">
        <InlineOverlay handleClose={this.props.closeWorkflow}>
          <InlineOverlayHeader>
            <FormattedMessage id={`add_to_my_shelf_${this.props.shelfName}`} />
          </InlineOverlayHeader>
          <InlineOverlayBody>
            <MessagingContainer id={this.props.workflowId}>
              {messageOptions => <Generic {...messageOptions} duration={false} />}
            </MessagingContainer>
          </InlineOverlayBody>
        </InlineOverlay>
      </div>
    );
  }
}

BatchAddedToShelfWorkflow.propTypes = {
  closeWorkflow: PropTypes.func,
  workflowId: PropTypes.string,
  shelfName: PropTypes.string
};



// WEBPACK FOOTER //
// ./app/components/borrowing/shared/BatchAddedToShelfWorkflow/BatchAddedToShelfWorkflow.jsx